export const purchaseAgreementColumns = () => {
  return [
    //商品描述
    {
      field: 'productDesc',
      title: '商品描述',
      editRender: {
        name: 'productDesc',
      },
      visible: true,
    },
    {
      field: 'productQuantity',
      title: '采购数量',
      editRender: {
        name: 'productQuantity',
      },
      visible: true,
    },
    {
      title: '合同价格',
      visible: false,
      field: 'contract',
      children: [
        //合同单价
        {
          field: 'businessContractUnitPrice',
          title: '合同单价',
          width: 150,
          editRender: {
            name: 'businessContractUnitPrice',
          },
          visible: false,
        },
        //价税合计金额
        {
          field: 'businessContractTotalAmount',
          title: '价税合计金额',
          width: 160,
          editRender: {
            name: 'businessContractTotalAmount',
          },
          visible: false,
        },
        //税额
        {
          field: 'businessContractTaxAmount',
          title: '税额',
          width: 120,
          editRender: {
            name: 'businessContractTaxAmount',
          },
          visible: false,
        },
        //净值
        // {
        //   field: 'businessContractPureAmount',
        //   title: '净值',
        //   width: 100,
        //   editRender: {
        //     name: 'businessContractPureAmount',
        //   },
        //   visible: false,
        // },
      ],
    },
    {
      field: 'materialType',
      width: 150,
      title: '料型',
      visible: false,
      editRender: { name: 'materialType' },
    },
    {
      field: 'taxRate',
      title: '增值税',
      agreement: true,
      editRender: {
        name: 'taxRate',
      },
      visible: false,
    },
    //合同单价(单独给外部协议)
    {
      field: 'businessContractUnitPrice',
      title: '合同单价',
      width: 150,
      editRender: {
        name: 'businessContractUnitPrice',
      },
      visible: false,
    },
    {
      field: 'businessContractTotalAmount',
      title: '价税合计金额',
      width: 160,
      editRender: {
        name: 'businessContractTotalAmount',
      },
      visible: false,
    },
    {
      field: 'isFixedPrice',
      title: '是否定价',
      agreement: true,
      editRender: {
        name: 'isFixedPrice',
      },
      visible: false,
    },
    {
      field: 'storageName',
      title: '仓库',
      width: 180,
      editRender: {
        name: 'storageName',
      },
      visible: false,
    },
    // TODO 字段要对接
    {
      title: '变动价格',
      field: 'price',
      visible: false,
      children: [
        {
          field: 'businessChangeUnitPrice',
          title: '变动单价',
          width: 150,
          editRender: {
            name: 'businessChangeUnitPrice',
          },
          visible: false,
        },
        {
          field: 'businessChangeTotalAmount',
          title: '价税合计金额',
          width: 160,
          editRender: {
            name: 'businessChangeTotalAmount',
          },
          visible: false,
        },
        //税额
        {
          field: 'businessChangeTaxAmount',
          title: '税额',
          width: 120,
          editRender: {
            name: 'businessChangeTaxAmount',
          },
          visible: false,
        },
        //净值  businessContractPureAmount
        // {
        //   field: 'businessChangePureAmount',
        //   title: '净值',
        //   width: 100,
        //   editRender: {
        //     name: 'businessChangePureAmount',
        //   },
        //   visible: false,
        // },
      ],
    },
    // TODO 需要对字段
    {
      field: 'priceConfirmDate',
      title: '价格确定时间',
      agreement: true,
      editRender: {
        name: 'priceConfirmDate',
      },
      visible: false,
    },
    {
      field: 'priceIdentity',
      title: '价格标识',
      agreement: true,
      editRender: {
        name: 'priceIdentity',
      },
      visible: false,
    },
    {
      field: 'unit',
      title: '单位',
      agreement: true,
      editRender: {
        name: 'unit',
      },
      visible: false,
    },
    {
      field: 'productQuantity1',
      title: '交货数量',
      editRender: {
        name: 'productQuantity1',
      },
      visible: false,
    },
    {
      field: 'productQuantity2',
      title: '销售数量',
      editRender: {
        name: 'productQuantity2',
      },
      visible: false,
    },
    {
      field: 'variablePrice',
      title: '变动单价',
      width: 150,
      editRender: {
        name: 'variablePrice',
      },
      visible: false,
    },
    {
      field: 'businessChangeUnitPrice',
      title: '变动后合同含税单价',
      width: 150,
      editRender: { name: 'businessChangeUnitPrice' },
      visible: false,
    },
    {
      field: 'shipmentPlace',
      width: 150,
      title: '起运地',
      editRender: { name: 'shipmentPlace' },
      visible: false,
    },
    {
      field: 'destination',
      width: 150,
      title: '目的地',
      editRender: { name: 'destination' },
      visible: false,
    },
  ];
};

export const tableRule = {
  productDesc: [{ required: true, message: '必填字段' }],
  isFixedPrice: [{ required: true, message: '必填字段' }],
  businessContractTotalAmount: [{ required: true, message: '必填字段' }],
  businessContractTaxAmount: [{ required: true, message: '必填字段' }],
  // businessChangePureAmount: [{ required: true, message: '必填字段' }],
  unit: [{ required: true, message: '必填字段' }],
  taxRate: [{ required: true, message: '必填字段' }],
  storageName: [{ required: true, message: '必填字段' }],
  productQuantity: [{ required: true, message: '必填字段' }],
  businessContractUnitPrice: [{ required: true, message: '必填字段' }],
  productQuantity2: [{ required: true, message: '必填字段' }],
  // businessChangeUnitPrice: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
  // productQuantity1: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
};
